export enum STOPWATCH {
    FLYING = 'flying',
    STANDING = 'standing',
    PURSUIT = 'pursuit',
}